import { render, staticRenderFns } from "./integration-card.vue?vue&type=template&id=7c47551c&scoped=true&"
import script from "./integration-card.vue?vue&type=script&lang=js&"
export * from "./integration-card.vue?vue&type=script&lang=js&"
import style0 from "./integration-card.vue?vue&type=style&index=0&id=7c47551c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c47551c",
  null
  
)

export default component.exports